<template>
  <article class="layout-section -align-side -reverse">
    <figure class="layout-section__figure -reverse" style="background-image: url('/images/image-2.jpg')" />

    <section class="layout-section__content">
      <h2 class="layout-section__title">Présentation étape par étape</h2>

      <article class="layout-steps">
        <section class="layout-steps__item">
          <div class="layout-steps__number">1</div>
          <div class="layout-steps__content">
            <h3 class="layout-steps__title">Téléchargez le formulaire</h3>
            <p>
              Commencez par télécharger le
              <span class="layout-steps__link">formulaire d’adhésion</span>
              .
            </p>
          </div>
        </section>

        <section class="layout-steps__item">
          <div class="layout-steps__number">2</div>
          <div class="layout-steps__content">
            <h3 class="layout-steps__title">Remplissez et envoyez</h3>
            <p>
              Remplissez-le avec soin, puis envoyez-le à
              <span class="layout-steps__link">info@icea.qc.ca</span>
              .
            </p>
          </div>
        </section>

        <section class="layout-steps__item">
          <div class="layout-steps__number">3</div>
          <div class="layout-steps__content">
            <h3 class="layout-steps__title">Étude et approbation</h3>
            <p>
              Votre demande sera étudiée par notre conseil d’administration. Une fois acceptée, vous recevrez un avis
              pour régler votre cotisation annuelle.
            </p>
          </div>
        </section>
      </article>
    </section>
  </article>
</template>

<script>
export default {
  name: 'DemoContentSteps'
}
</script>
